export const FirebaseErrorCodes = {
  AUTH_USER_NOT_FOUND: "auth/user-not-found",
  AUTH_INTERNAL_ERROR: "auth/internal-error",
  USER_EXISTS_CLOUD_FUCTION: "already-exists",
  USER_DISABLED: "auth/user-disabled",
  AUTH_INVALID_NUMBER: "auth/invalid-phone-number",
};
